import React from 'react';

const ByTheWay = () => {
  return (
    <section className="Informo ByTheWay">
      <h2 className="Pacifico">Before You Leave...</h2>
      <p>Part of the purpose of this site is to serve as my own “Jon-brand” personal/professional
        networking platform. If you work in tech, I’d love to connect with you if we haven’t already.
        Regardless of your job, if you have received some of the weed I’ve grown it’s because I think
        you are a wonderful and awesome person. Thanks, and I hope you enjoy your cannabis.</p>
        <div>
          <p>Many paths of communication exist:</p>
          <span className="LinksContainer">
            <a className="ContactLinks"
              href="https://www.jonforney.com">www.jonforney.com</a>
            <a className="ContactLinks"
              href="https://www.linkedin.com/in/jon-forney/">www.linkedin.com/in/jon-forney/
              </a>
            <a className="ContactLinks" 
              href="https://twitter.com/GodzillaJonny">@godzillajonny</a>
            <a className="ContactLinks" 
              href="mailto:jonathan.forney@gmail.com">jonathan.forney@gmail.com</a>
          </span>
        </div>
    </section>
  )
}

export default ByTheWay;
